module.exports = __webpack_public_path__ + "aa656877bf592d87e34a87aad1fd9a27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/etsy_2023_chart.png
// module id = 1669
// module chunks = 0